import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import { FaRegTrashAlt } from 'react-icons/fa';
import { BsDot } from 'react-icons/bs';
import { ObjModal } from '../../../../contexts';
import AddGift from '../../../Modals/AddGift';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Chip from '@mui/material/Chip';
import { removeGift } from '../../../../common/api';
import { toast } from 'react-toastify';


const Gifts = ( { aid, uid } ) => {
    const { obj, objType, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( false );

    useEffect( () => {
        setExpanded( obj.gifts.length > 0 );
    }, [ obj.gifts ] );

    const trash = async ( gaid, gid ) => {
        const removed = await removeGift( gaid, uid, gid );
        if ( removed.length ) {
            toast.success( 'The gift has been deleted', { theme: 'dark' } );
            // window.location.reload( false );
        }
    };

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'gift':
                setModal( <AddGift close={closeModal} obj={obj} objType={objType} /> ); 
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>Gifts ({obj.gifts.length})</Typography></Col>
                        <Col xs='auto' className='p-0'><Button variant='outline-primary' size='sm' onClick={ () => handleModal( 'gift' ) }>+ Add</Button></Col>
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <ListGroup variant='flush'>
                    { obj.gifts.map( ( g, idx ) => (
                        <ListGroup.Item key={idx}>
                            <Row className='align-items-center'>
                                <Col xs='auto' className='tf-sidebar-obj-value'>
                                    {g.reason}
                                </Col>
                                <Col>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='tf-sidebar-obj-key-date-container pe-1'>
                                            <span className='tf-sidebar-obj-key-date'>
                                                <Link to={`/gift/${g.gid}`}>{g.name}</Link>
                                            </span>
                                        </Col>
                                        <Col xs='auto' className='p-0'><BsDot /></Col>
                                        <Col xs='auto' className='p-1'>{g.giftDate}</Col>
                                        <Col xs='auto' className='p-0'><BsDot /></Col>
                                        <Col xs='auto' className='p-1'>${g.price}</Col>
                                    </Row>
                                </Col>
                                <Col xs='auto'><FaRegTrashAlt className='tf-sidebar-trash' onClick={ () => trash( g.aid, g.gid ) } /></Col>
                            </Row>
                        </ListGroup.Item>
                    ) ) }
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email
} );

const mapDispatch = ( dispatch ) => ( {
    // loadTasks: dispatch.contacts.loadContactTasks,
} );

export default connect( mapProps, mapDispatch )( Gifts );